

function UploadFiles( whistle, $, params ){

	var me = this;
	me.fileInputCounter = 0;

	me.clickUploadLink = function( ev ){
		ev.preventDefault();
		$(this).blur();
		
		var selectorSuffix = me.elementToSelectorSuffix(this);
		var namespace = $(this).data('namespace');
		
		// Find the active (empty) file input or create a new one
		var $activeInput = $('.uploadFiles' + selectorSuffix + ':not(.has-files)').first();
		
		if ($activeInput.length === 0) {
			// Create a new file input
			$activeInput = me.createNewFileInput(namespace);
		}
		
		$activeInput.click();
	};

	me.createNewFileInput = function(namespace){
		me.fileInputCounter++;
		var namespaceAttr = namespace ? 'data-namespace="' + namespace + '"' : '';
		var selectorSuffix = namespace ? '[data-namespace=' + namespace + ']' : ':not([data-namespace])';
		var $container = $('.uploadFilesContainer' + selectorSuffix);
		
		// Get the name attribute from the original input or use default
		var $originalInput = $('.uploadFiles' + selectorSuffix).first();
		var nameAttr = $originalInput.length > 0 ? $originalInput.attr('name') : 'file[]';
		
		var $newInput = $('<input type="file" multiple class="uploadFiles" ' +
			'name="' + nameAttr + '" ' +
			'id="file-' + me.fileInputCounter + '" ' + namespaceAttr + ' />');
		
		// Add to the upload container
		if ($container.length === 0) {
			// Fallback: add to the hidden div
			$newInput.appendTo($('.uploadArea' + selectorSuffix).siblings('.hide').first());
		} else {
			$newInput.appendTo($container);
		}
		
		$newInput.change(me.changeOfUploadFiles);
		
		return $newInput;
	};

	me.elementToSelectorSuffix = function(element){
		var namespace = $(element).data('namespace');
		var suffix = '';
		if(namespace){
			suffix = '[data-namespace=' + namespace + ']';
		} else {
			suffix = ':not([data-namespace])';
		}
		return suffix;
	}

	me.namespaceAttribute = function(element){
		var namespace = $(element).data('namespace');
		var attribute = '';
		if(namespace){
			attribute = 'data-namespace="' + namespace + '"';
		}
		return attribute;
	}

	me.changeOfUploadFiles = function(){
		var $input = $(this);
		var selectorSuffix = me.elementToSelectorSuffix(this);
		var namespaceAttribute = me.namespaceAttribute(this);
		var files = $input.prop('files');
		var $fileNames = $('.fileNames' + selectorSuffix);

		if( !files || files.length === 0 ){
			return;
		}
		
		// Mark this input as having files
		$input.addClass('has-files');
		
		var inputId = $input.attr('id');
		var names = $.map(files, function(val) { return val.name; });
		
		$fileNames.removeClass('hide');

		// Create a group div for this batch of files
		var $fileGroup = $('<div class="fileGroup" data-input-id="' + inputId + '"></div>');
		
		$( names ).each( function( ){
			$fileGroup.append( '<div class="fileToUpload">' +
				"<i class='fa fa-paperclip'></i> " +
				this + '</div>' );
		} );
		
		// Add remove button for this specific group
		$fileGroup.append('<button type="button" class="btn btn-default btn-xs fa fa-times removeFileGroupButton" ' +
			namespaceAttribute + ' data-input-id="' + inputId + '"></button>');
		
		$fileNames.append($fileGroup);
		
		$('.removeFileGroupButton[data-input-id="' + inputId + '"]').click( me.clickRemoveFileGroupButton );
	};

	me.clickRemoveFileGroupButton = function(){
		var inputId = $(this).data('input-id');
		var selectorSuffix = me.elementToSelectorSuffix(this);
		
		// Remove the file input
		$('#' + inputId).remove();
		
		// Remove the file group display
		$('.fileGroup[data-input-id="' + inputId + '"]').remove();
		
		// If no more files, hide the fileNames container
		if ($('.fileNames' + selectorSuffix + ' .fileGroup').length === 0) {
			$('.fileNames' + selectorSuffix).addClass('hide').empty();
		}
	}

	me.clickRemoveFilesButton = function(){
		var selectorSuffix = me.elementToSelectorSuffix(this);
		
		// Remove all file inputs with files
		$('.uploadFiles' + selectorSuffix + '.has-files').remove();
		
		// Clear the display
	    $('.fileNames' + selectorSuffix).empty().addClass('hide');
	    
	    me.observe();
	}

	me.observe = function(){
		$('.uploadLink').off().click( me.clickUploadLink );
		$('.uploadFiles').off().change( me.changeOfUploadFiles );
	};

	me.observe();
}